// extracted by mini-css-extract-plugin
export default {"heading":"Availability_heading__qJ3FU","wrapper":"Availability_wrapper__h6ZMj"};